// extracted by mini-css-extract-plugin
export default {"abstract":"Abstraction_abstract__7XKwQ"};